/*
 * @Author: Src
 * @Date: 2024-12-17 19:15:24
 * @LastEditTime: 2024-12-24 09:27:45
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/router/shop.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import AddShop from '@/views/shop/AddShop.vue';
import ShopList from '@/views/shop/ShopList.vue';
import DetailShop from '@/views/shop/DetailShop.vue';

const shopRoutes: RouteConfig[] = [
    {
        name: 'shop',
        path: '/shop/list',
        component: ShopList,
        meta: {
            title: '门店列表',
        },
    },
    {
        name: 'shop-add',
        path: '/shop/add',
        component: AddShop,
        meta: {
            title: '新增门店',
        },
    },
    {
        name: 'shop-detail',
        path: '/shop/detail/:id',
        component: DetailShop,
        meta: {
            title: '门店详情',
        },
    },
];

export default shopRoutes;
